module.exports = __webpack_public_path__ + "img/13.153a08e1.jpg";